__webpack_require__.p = "https://nek0meshi.github.io/tetris/";